import { render, staticRenderFns } from "./EditPutawayForm.vue?vue&type=template&id=218fb5fe"
import script from "./EditPutawayForm.vue?vue&type=script&lang=js"
export * from "./EditPutawayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports